import { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import styles from "./style.module.css";

import MainButton from "../../../components/Admin/MainButton/MainButton";
import ButtonListClass from "../../../components/Admin/ButtonListClass/ButtonListClass";
import EditClass from "../../../components/Admin/EditClass/EditClass";
import NewTable from "../../../components/Admin/NewTable/NewTable";
import { listControllerContext } from "../../../contextAdmin/Admin/List";
import { classList } from "./data";

// import { headerText } from "../../../contextAdmin/hederText";
import { popupContext } from "../../../contextAdmin/Admin/Popup";
import classRequets from "../../../components/api/classRequest";
import { HeaderTextContext } from "../../../contextAdmin/hederText";
import { calcCurrList } from "../../../functions/pagination";
import adminRequets from "../../../components/api/adminRequests";
import { userContext } from "../../../contextAdmin/Admin/User";

//Creator : Team E - Chanan
function Classroom() {
  // const [hederText, setHeaderText] = useContext(headerText);
  const { setPopup } = useContext(popupContext);
  const { list, setList } = useContext(listControllerContext)
  const { setHeaderText } = useContext(HeaderTextContext)
  const { user, setUser } = useContext(userContext);

  setHeaderText("")

  const [itemsPerPage, setItemsPerPage] = useState(7)
  const [paginationData, setPaginationData] = useState(list && list.length ? calcCurrList(list, 1, itemsPerPage) : { currentItems: [], totalPages: 1, pageToShow: 1 })
  console.log("🚀 ~ file: Classroom.jsx:33 ~ Classroom ~ paginationData:", paginationData)
  useEffect(() => {
    try {
      setTimeout(() => {
        let AllClasses = classRequets.getAllTeacherClasses(user.id).then(res => setList(res))

      }, 1000)
    } catch (error) {
      console.log("🚀 ~ file: Classroom.jsx:34 ~ useEffect ~ error:", error)

    }
  }, [])
  async function onSubmit(newClassDetails) {
    return await classRequets.createNewClass(newClassDetails);
  }
  useEffect(() => {
    console.log("🚀 ~ useEffect ~ list:", list)

    if (list.length) {
      let pageToShow = Math.ceil(list.length / itemsPerPage) > paginationData.totalPages ? paginationData.totalPages + 1 : paginationData.pageToShow//check if the new user is in new page
      //TODO: fix that pagination so new user will be move to it
      let CurrentToShow = calcCurrList(list, paginationData.pageToShow, itemsPerPage)
      setPaginationData(CurrentToShow)

    } else {
      setPaginationData({ currentItems: [], totalPages: 1, pageToShow: 1 })
    }
  }, [list])

  useEffect(() => {
    if (list.length) {
      let CurrentToShow = calcCurrList(list, paginationData.pageToShow, itemsPerPage)
      setPaginationData(CurrentToShow)

    }
  }, [paginationData.pageToShow])

  const openEditClass = () => setPopup(<EditClass type={"New Classroom"} onSubmit={onSubmit}>Add class</EditClass>)

  return (
    <div className={styles.container}>
      <button onClick={openEditClass} className={`${styles["addButton"]} btn`}>
        Add New Classroom
      </button>

      {paginationData.totalPages > 1 &&
        <div className={styles["buttonListClass"]}>
          <ButtonListClass
            totalPages={paginationData.totalPages}
            setPaginationData={setPaginationData}
            pageActive={paginationData.pageToShow}
          />
        </div>}
      <div className={styles["mainTable"]}>
        <NewTable currList={paginationData.currentItems} typ={"class"} />
      </div>


    </div>
  );
}

export default Classroom;
